<template>
    <div class="modal fade" :id="id" tabindex="-1" aria-modal="false" role="dialog" >
        <div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
          <div class="modal-content p-3 p-md-5">
            <div class="modal-body">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              <div class="text-center mb-4">
                <h3 class="mb-2">Leave A Review</h3>
                <p class="text-muted">How Would You Rate This Course</p>
              </div>
              <form id="addNewCCForm" class="row g-3 fv-plugins-bootstrap5 fv-plugins-framework" onsubmit="return false" novalidate="novalidate">
                <div class="centered-container">
                    <star-rating v-model="ratings" @rated="onRated" :size="36" :disabled="false"/>
                </div>
                
                <div class="col-12 fv-plugins-icon-container mt-0">
                  <label class="form-label w-100" for="modalAddCard">Write A Review <small>(optional)</small></label>
                  <div class="input-group input-group-merge has-validation">
                    <input  class="form-control credit-card-mask" type="text" placeholder="Write A Review" v-model="review">
                  </div>
                </div>
                <div class="col-12 mt-1 text-center">
                  <button type="submit" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light" @click="updateReview">Submit</button>
                  <button type="reset" class="btn btn-label-secondary btn-reset waves-effect" data-bs-dismiss="modal" aria-label="Close" ref="closer">Cancel</button>
                </div>
              <input type="hidden">
            </form>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import { useEducationStore } from '../../../../../stores/EducationStore.js'
import {hideModal} from '../../../../../utilities/_helpers'
import { reactive, ref } from "vue";

export default {
    components:{
    },
    props:{
        id:String
    },
    setup(){
        const ratings = ref(4.5),
        review = ref(null);
        return{
            ratings,review,
            educationStore: useEducationStore(),
            hideModal:hideModal
        }
    },
    methods: {
        onRated(rating) {
            this.ratings = rating;
        },
        updateReview(){
            let $this = this;
            const route = this.$router.resolve({
                name:'course-review',
                params:{
                    course: this.$route.params.course
                }
            });
            const payload = {
                ratings : this.ratings,
                review : this.review
            }
            axios.post(
                route.href,
                payload
            ).then(function(response) {
                if(response.data.error == true){
                    toastr.error(response.data.message, 'Course Rating Error');
                }
                toastr.success(response.data.message, 'Course Rating');
                $this.educationStore.content.has_reviewed =  true
                $this.educationStore.reviewed = true
                $this.educationStore.rating.total += $this.ratings;
                $this.educationStore.rating.count += 1;
                $this.$refs.closer.click();
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    toastr.error(error.response.data.response_msg, 'Error!');
                }, 2000)
            });
        }
    },
}
</script>
<style>
.centered-container {
  margin: auto;
  text-align: center;
  display: flex;
  justify-content: center; 
  align-items: center;
}
</style>